import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store/store';
import variables from '../../assets/styles/variables.module.scss';

export interface IKnowledgeGraphColorPalette {
    person?: string,
    place?: string,
    event?: string,
    organization?: string,
    thing?: string,
    background?: string,
    label?: string,
    selected?: string,
    parent?: string,
    edge?: string,
    language?: string,
    norp?: string,
    product?: string,
    email?: string,
    phone?: string,
    socialmedia?: string,
    school?: string,
    score?: string
}

interface IPreferencesState {
  colorPalette: IKnowledgeGraphColorPalette
}

// Define the initial state using that type
const initialState: IPreferencesState = {
  colorPalette: JSON.parse(localStorage.getItem('colorPalette')) || {
      background: variables.color_background_dark,
      edge: variables.color_steel_grey,
      label: variables.color_white,
      selected: variables.color_yellow,
      parent: variables.color_steel_grey,
      person: variables.color_orange,
      organization: variables.color_primary,
      place: variables.color_purple,
      event: variables.color_steel_grey,
      thing: variables.color_tertiary,
      language: variables.color_light_purple,
      norp: variables.color_light_yellow,
      product: variables.color_light_red,
      email: variables.color_teal,
      phone: variables.color_seafoam,
      socialmedia: variables.color_blue_linkedin,
      school: variables.color_primary,
      score: variables.color_score,
      website: variables.color_website,
      certification: variables.color_certification
  }
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setColorPalette: (state, action: PayloadAction<IKnowledgeGraphColorPalette>) => {
        state.colorPalette = {
            ...state.colorPalette,
            ...action.payload
        };
        localStorage.setItem('colorPalette', JSON.stringify(state.colorPalette));
    }
  }
});

export const {
  setColorPalette
} = preferencesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectColorPalette = (state: RootState): IKnowledgeGraphColorPalette => state.preferences.colorPalette;

export default preferencesSlice.reducer;
